import { init } from "@sentry/react";
init({
  dsn: "",
  enabled: import.meta.env.PROD,
});
